/**
 * « À faire » dans « Mes chambres » (web et mobile) : une chambre libre sale, ou une
 * recouche du jour pas encore faite (chambre occupée, `stayover_due` calculé par le
 * serveur). Module feuille (aucun import) : le mobile peut l'atteindre.
 */
export function estAFaire(chambre: { status: string; stayover_due?: boolean }): boolean {
    return chambre.status === 'free_dirty' || chambre.stayover_due === true;
}
